module.exports = __webpack_public_path__ + "static/media/kai.e531ddde.png";